import { getUnreadNotificationCount } from '@/services/cooking-api/notifications';
import { BellOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';
import { history } from '@umijs/max';
import { useEffect, useState } from 'react';

export default function NotificationBell() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let mounted = true;
    getUnreadNotificationCount()
      .then((response) => {
        if (mounted && response.code === 0) {
          setCount(response.data?.count || 0);
        }
      })
      .catch(() => {
        if (mounted) setCount(0);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Badge count={count} size="small">
      <Button
        type="text"
        icon={<BellOutlined />}
        onClick={() => history.push('/system/notifications')}
      />
    </Badge>
  );
}
